import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        // You can also log error messages to an error reporting service here
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <div>
                    <Alert style={{ whiteSpace: 'pre-wrap' }} variant="danger">
                        Whoops! Something went wrong. Please try{' '}
                        <a href=".">reloading the page</a>. If this error
                        persists, please{' '}
                        <a href="https://deltek.custhelp.com">
                            contact support
                        </a>{' '}
                        with the below error information:
                        <br />
                        <br />
                        {this.state.error && this.state.error.toString()}
                        {this.state.errorInfo.componentStack}
                    </Alert>
                </div>
            )
        }

        return this.props.children;
    }
}
